export enum TabType {
  Members = "members",
  Tickets = "tickets",
}

export enum MemberRoleSection {
  TicketCreator = "ticket-creator",
  DefaultAssignee = "default-assignee",
  ProjectLead = "project-lead",
}

export const memberMenuSectionLabels: Record<MemberRoleSection, string> = {
  [MemberRoleSection.TicketCreator]: "Ticket creator",
  [MemberRoleSection.DefaultAssignee]: "Default assignee",
  [MemberRoleSection.ProjectLead]: "Project lead",
};
